<div *ngIf="imgUrl != ''">
  <img 
    [src]="imgUrl" 
    [alt]="imgAlt || ''" 
    [class]="cssClass || ''"
    style="height: 230px;width:100%;    object-fit: cover;
    object-position: center;"
  />
</div>
